// Serbian JMBG: DD MM YYY RR BBB K (13 digits).
//   DDMMYYY — date of birth; YYY is the year's last three digits
//             (9xx = 1900s, 0xx = 2000s)
//   RR      — registration region, BBB — unique number
//   K       — check digit: m = 11 - ((7(a+g) + 6(b+h) + 5(c+i) + 4(d+j)
//             + 3(e+k) + 2(f+l)) mod 11); K = m, or 0 when m is 10 or 11.
// Keep in sync with gs.be helpers/jmbg.js, which enforces the same rule.
export const isValidJmbg = (value) => {
  const jmbg = String(value || "").trim();
  if (!/^\d{13}$/.test(jmbg)) return false;
  const d = jmbg.split("").map(Number);

  const day = d[0] * 10 + d[1];
  const month = d[2] * 10 + d[3];
  const yyy = d[4] * 100 + d[5] * 10 + d[6];
  const year = yyy >= 800 ? 1000 + yyy : 2000 + yyy;
  const birth = new Date(year, month - 1, day);
  if (
    birth.getFullYear() !== year ||
    birth.getMonth() !== month - 1 ||
    birth.getDate() !== day ||
    birth > new Date()
  ) {
    return false;
  }

  const sum =
    7 * (d[0] + d[6]) +
    6 * (d[1] + d[7]) +
    5 * (d[2] + d[8]) +
    4 * (d[3] + d[9]) +
    3 * (d[4] + d[10]) +
    2 * (d[5] + d[11]);
  let control = 11 - (sum % 11);
  if (control > 9) control = 0;
  return control === d[12];
};
